import React from 'react';
function Urgent() {
    return (React.createElement("g", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12 6L6 12L7.41 13.41L12 8.83L16.59 13.41L18 12L12 6Z" }),
        React.createElement("path", { d: "M12 11.4998L6 17.4998L7.41 18.9098L12 14.3298L16.59 18.9098L18 17.4998L12 11.4998Z" })));
}
export default Urgent;
